import { useQuery } from '@tanstack/react-query'

import { useGitlabClient } from './adapters/GitlabClient'

export function useUsersList() {
  const gitlabClient = useGitlabClient()

  const { data: users } = useQuery({
    queryKey: ['users', gitlabClient],
    async queryFn() {
      const values = (
        await gitlabClient.Users.all({
          active: true,
        })
      )
        .filter((u) => {
          if (u.username === 'cockpit_bot') return false
          if (u.username.match(/project_\d+_bot_/)) return false
          return true
        })
        .sort((a, b) => a.name.localeCompare(b.name))
      return values
    },
  })

  return users
}
